var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-hidden"},[_c('svg-circle',{staticClass:"stroke-light position-absolute top-right"}),(_vm.title)?_c('h1',{staticClass:"text-capitalize"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }